<template>
    <v-card class="rounded-0">
        <v-toolbar class="no-printable" color="primary" dark>
            
            <v-btn @click="cancelPrint" icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Impression Facture N°{{factureToPrint.num_facture}}</v-toolbar-title>
            <v-select
            width="100px"
            class="ml-5"
            :items="['Prime', 'Unibox']"
            v-model="societe"
            hide-details
            dense
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn @click="print" text>
                Confirmer
                <v-icon>mdi-check</v-icon>
            </v-btn>

        </v-toolbar>
        <template v-if="factureToPrint.is_magasinage !== 0">
            <div class="fullwidth" v-if="societe === 'Prime'">
                <div class="width-50">
                    <div class="printable-content">
                        <img class="logo" src="https://i.imgur.com/J8CnA93.png" />
                    </div>
                </div>
                <div class="width-50">
                    <div class="printable-content">
                        <div class="info-text">
                            <b>Prime Shipping Agency </b><br/>
                            3 Rue Habib Thameur 1er Etage App N°2 Rades 2040 <br/>
                            Ben Arous Tunisie. Tél. : +216 71 461 710 <br/>
                            Email : manager@primeshipping.tn <br/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fullwidth" v-if="societe === 'Unibox'">
                <div class="width-50">
                    <div class="printable-content">
                        <img class="logo" src="https://i.imgur.com/LBw0phu.jpg" />
                    </div>
                </div>
                <div class="width-50">
                    <div class="printable-content">
                        <div class="info-text">
                            <b>Unibox Express Delivery</b><br/>
                            Rue de l'exportation Zone Industrielle rades 2040 <br/>
                            Ben Arous Tunisie. Tél. : +216 71 461 699  <br/>
                            Email : safa.masri@unibox.tn <br/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="fullwidth">
                <div class="printable-content">
                    <h3>{{factureToPrint.libelle}} N°{{factureToPrint.num_facture}}</h3>
                </div>
            </div>
            <div class="line"></div>
            <div class="clearfix"></div>
            <div class="fullwidth">
                <div class="width-50">
                    <div class="printable-content m-t-0 p-t-0 p-b-0 m-t-0">
                        <div class="width-50">
                            <span class="client-label">Date : {{factureToPrint.date | formatDate}} </span>
                        </div>
                        <div class="width-50" v-if="factureToPrint.dossier">
                            <span class="client-label">Dossier N° : {{factureToPrint.dossier.num_dossier}} </span>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="width-33">
                    <div class="fullwidth">
                        <div class="printable-content m-t-0 p-t-0">
                            <div class="coordonnee-client" v-if="factureToPrint.client">
                                <p class="text-line"><b>{{factureToPrint.client.fullname}}</b></p>
                                <p class="text-line">{{factureToPrint.client.adresse}}</p>
                                <p class="text-line">{{factureToPrint.client.region}} - {{factureToPrint.client.code_postal}}</p>
                                <p class="text-line">Tel : {{factureToPrint.client.tel}} <span v-if="factureToPrint.client.fax">- Fax : {{factureToPrint.client.fax}}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="width-33">
                    <div class="fullwidth">
                        <div class="printable-content  m-t-0 p-t-0">
                            <div class="p-t-1">
                                <div class="facture-data" v-if="factureToPrint.dossier">
                                    <div class="facture-data-row">
                                        <div class="width-33"><div class="data-label">Type/Classe</div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.type}} - {{factureToPrint.dossier.classe}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe !== 'Aérien'">
                                        <div class="width-33"><div class="data-label">Navire</div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.navire}}</div></div>
                                    </div>
                                    
                                    <div class="facture-data-row" v-else>
                                        <div class="width-33"><div class="data-label">Comp.Aérienne</div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.compagnie_aerienne}}</div></div>
                                    </div>
                                    
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe !== 'Aérien'">
                                        <div class="width-33"><div class="data-label">Embarqué De</div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.port_from_name}} Le {{factureToPrint.dossier.from_date | formatDate}}</div></div>
                                    </div>
                                    
                                    <div class="facture-data-row" v-else>
                                        <div class="width-33"><div class="data-label">Départ De </div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.aeroport_depart}} Le {{factureToPrint.dossier.from_date | formatDate}}</div></div>
                                    </div>

                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe !== 'Aérien'">
                                        <div class="width-33"><div class="data-label">Débarquée à</div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.port_to_name}} Le {{factureToPrint.dossier.to_date | formatDate}}</div></div>
                                    </div>

                                    <div class="facture-data-row" v-else>
                                        <div class="width-33"><div class="data-label">Arrivée à </div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.aeroport_arrivee}} Le {{factureToPrint.dossier.to_date | formatDate}}</div></div>
                                    </div>

                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe !== 'Aérien'">
                                        <div class="width-33"><div class="data-label">Voyage</div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.voyage}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe !== 'Aérien'">
                                        <div class="width-33"><div class="data-label">Escale</div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.escale}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Groupage'">
                                        <div class="width-33"><div class="data-label">Conteneur N°</div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.conteneur_num}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Groupage'">
                                        <div class="width-33"><div class="data-label">N°Esc.Magasin</div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.num_escale_magasin}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Groupage'">
                                        <div class="width-33"><div class="data-label">Date.Dépotage</div></div>
                                        <div class="width-66"><div class="data-value">{{factureToPrint.dossier.date_depotage | formatDate}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Groupage'">
                                        <div class="width-33"><div class="data-label">Date.Enlèvement</div></div>
                                        <div class="width-66"><div class="data-value">{{factureData.date_enlevement | formatDate}}</div></div>
                                    </div>
                                    
                                </div>
                                
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="width-33">
                    <div class="fullwidth">
                        <div class="printable-content  m-t-0 p-t-0">
                            <div class="coordonnee-client">
                                <div class="facture-data" v-if="factureToPrint.avis">
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe !== 'Aérien'">
                                        <div class="width-50"><div class="data-label">B/L N°</div></div>
                                        <div class="width-50"><div class="data-value">{{factureToPrint.avis.bl}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Aérien'">
                                        <div class="width-50"><div class="data-label">N°LTA</div></div>
                                        <div class="width-50"><div class="data-value">{{factureToPrint.dossier.num_lta}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Aérien'">
                                        <div class="width-50"><div class="data-label">N°Vol</div></div>
                                        <div class="width-50"><div class="data-value">{{factureToPrint.dossier.num_vol}}</div></div>
                                    </div>
                                    <div class="facture-data-row">
                                        <div class="width-50"><div class="data-label">Fournisseur</div></div>
                                        <div class="width-50"><div class="data-value">{{factureToPrint.avis.fournisseur}}</div></div>
                                    </div>
                                    <div class="facture-data-row">
                                        <div class="width-50"><div class="data-label">P/C</div></div>
                                        <div class="width-50">
                                            <div class="data-value" v-if="factureToPrint.avis.pc.length > 1">{{factureToPrint.avis.pc}}</div>
                                            <div class="data-value" v-else>-</div>
                                        </div>
                                    </div>
                                    <div class="facture-data-row">
                                        <div class="width-50"><div class="data-label">Terme</div></div>
                                        <div class="width-50"><div class="data-value">{{factureToPrint.avis.terme}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Groupage'">
                                        <div class="width-50"><div class="data-label">Valeur</div></div>
                                        <div class="width-50"><div class="data-value">{{factureToPrint.avis.valeur}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Groupage'">
                                        <div class="width-50"><div class="data-label">Bureau</div></div>
                                        <div class="width-50"><div class="data-value">{{factureToPrint.avis.bureau}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Groupage'">
                                        <div class="width-50"><div class="data-label">Code Magasin</div></div>
                                        <div class="width-50"><div class="data-value">{{factureToPrint.avis.code_magasin}}</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Groupage'">
                                        <div class="width-50"><div class="data-label">Durée Magasinage</div></div>
                                        <div class="width-50"><div class="data-value">{{factureData.nb_jours}} Jour(s)</div></div>
                                    </div>
                                    <div class="facture-data-row" v-if="factureToPrint.dossier.classe === 'Groupage'">
                                        <div class="width-50"><div class="data-label">Franchise</div></div>
                                        <div class="width-50"><div class="data-value">{{factureData.franchise}} Jour(s)</div></div>
                                    </div>
                                </div>
                                

                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="fullwidth" v-if="factureToPrint.marchandise && factureToPrint.marchandise.length > 0">
                    <div class="printable-content p-t-0 m-t-0">
                        <table border=0 class="table-print" width="100%" v-if="factureToPrint.dossier">
                            <tr class="heading">
                                <td>Rub</td>
                                <td>Colis</td>
                                <td  v-if="factureToPrint.dossier.classe !== 'Groupage' && factureToPrint.dossier.classe !== 'Aérien' ">Cont.Numéro</td>
                                <td  v-if="factureToPrint.dossier.classe !== 'Groupage' && factureToPrint.dossier.classe !== 'Aérien' ">Cont.Type</td>
                                <td>Désignation Marchandises</td>
                                <td>Poids</td>
                                <td v-if="factureToPrint.dossier.classe === 'Groupage'">Volume</td>
                            </tr>
                            <tr v-for="marchandise in factureToPrint.marchandise" class="border-bottom-1" v-bind:key="marchandise.id">
                                <td>{{marchandise.rub}}</td>
                                <td>{{marchandise.colis}}</td>
                                <td v-if="factureToPrint.dossier.classe !== 'Groupage' && factureToPrint.dossier.classe !== 'Aérien' ">{{marchandise.cont_numero}}</td>
                                <td v-if="factureToPrint.dossier.classe !== 'Groupage' && factureToPrint.dossier.classe !== 'Aérien' ">{{marchandise.cont_type}}</td>
                                <td>{{marchandise.description}}</td>
                                <td>{{marchandise.poids}}</td>
                                <td  v-if="factureToPrint.dossier.classe === 'Groupage'">{{marchandise.volume}}</td>
                            </tr>
                        </table>
                        <table border=0 class="table-print" width="100%" v-else>
                            <tr class="heading">
                                <td>Rub</td>
                                <td>Colis</td>
                                <td>Cont.Numéro</td>
                                <td>Cont.Type</td>
                                <td>Désignation Marchandises</td>
                                <td>Poids</td>
                                <td>Volume</td>
                            </tr>
                            <tr v-for="marchandise in factureToPrint.marchandise" class="border-bottom-1" v-bind:key="marchandise.id">
                                <td>{{marchandise.rub}}</td>
                                <td>{{marchandise.colis}}</td>
                                <td>{{marchandise.cont_numero}}</td>
                                <td>{{marchandise.cont_type}}</td>
                                <td>{{marchandise.description}}</td>
                                <td>{{marchandise.poids.toLocaleString()}}</td>
                                <td>{{marchandise.volume}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="fullwidth">
                    <div class="printable-content">
                        <table border=0 class="table-print" width="100%">
                            <tr class="heading">
                                <td>Description Préstation</td>
                                <td >Montant</td>
                                <td>Taux TVA</td>
                                <td>Montant TVA</td>
                                <td>Devise</td>
                                <td>Mont.Devise</td>
                                <td>Cours</td>
                                <td width="20%">Montant TTC</td>
                            </tr>
                            <tr  class="border-bottom-1" v-for="prestation in factureToPrint.prestations" v-bind:key="prestation.id">
                                <td>{{prestation.description}}</td>
                                <td>{{Number(prestation.montant).toFixed(3)}}</td>
                                <td>{{prestation.tva}}</td>
                                <td>{{prestation.montantTva.toFixed(3)}}</td>
                                <td>{{prestation.devise}}</td>
                                <td v-if="Number(prestation.montantDevise) === 0"></td>
                                <td v-else>{{Number(prestation.montantDevise).toFixed(2)}}</td>
                                <td v-if="Number(prestation.cour) === 0"></td>
                                <td v-else>{{prestation.cour}}</td>
                                <td>{{Number(Number(Number(prestation.montant).toFixed(3)) + Number(prestation.montantTva.toFixed(3))).toFixed(3)}}</td>
                            </tr>
                            <tr>
                                <td  colspan="3" rowspan="5">
                                    <div class="printable-content border-1">
                                        Arrêté la présente facture à la somme de : {{totaltext}}
                                    </div>
                                </td>
                                <td  colspan="2" rowspan="5" valign="top">
                                    <table>
                                        <tr class="border-bottom-1" >
                                            <td>Taux</td>
                                            <td>Assiette</td>
                                            <td>Montant</td>
                                        </tr>
                                        <tr class="border-bottom-1"  v-for="(assie,key) in assiette" v-bind:key="key">
                                            <td>{{assie.taux}}</td>
                                            <td>{{assie.assiette.toFixed(3)}}</td>
                                            <td>{{assie.tva.toFixed(3)}}</td>
                                        </tr>
                                    </table>
                                </td>
                                <td align="right" colspan="2"><b>Total Non-Taxable</b></td>
                                <td align="left">
                                    {{totalnt.toFixed(3)}}
                                </td>
                            </tr>
                            <tr>
                                <td align="right" colspan="2" width="20%"><b>Total Taxable</b></td>
                                <td align="left">
                                    {{totalt.toFixed(3)}}
                                </td>
                            </tr>
                            <tr>
                                <td align="right" colspan="2"><b>Total TVA</b></td>
                                <td align="left">
                                    {{totaltva.toFixed(3)}}
                                </td>
                            </tr>
                            <tr>
                                <td align="right" colspan="2"><b>Timbre Fiscal</b></td>
                                <td align="left">
                                    {{currentFacture.timbre.toFixed(3)}}
                                </td>
                            </tr>
                            <tr>
                                <td align="right" colspan="2"><b>Total TTC</b></td>
                                <td align="left">
                                    {{total.toFixed(3)}}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="fullwidth">
                    
                </div>
                <div class="clearfix"></div>
                <div class="line"></div>
                <div class="fullwidth" v-if="factureToPrint.reglement && factureToPrint.reglement.length > 0">
                    <div class="printable-content">
                        <table border=0 class="table-print-reglement" width="100%">
                            <tr class="heading">
                                <td>Client</td>
                                <td>Mode Réglement</td>
                                <td>Banque</td>
                                <td>N°Pièce</td>
                                <td>Montant</td>
                            </tr>
                            <tr  class="border-bottom-1" v-for="reglement in factureToPrint.reglement" v-bind:key="reglement.id">
                                <td>{{reglement.client}}</td>
                                <td>{{reglement.mode}}</td>
                                <td>{{reglement.banque}}</td>
                                <td>{{reglement.num_piece}}</td>
                                <td>{{reglement.montant.toFixed(3)}} TND</td>

                            </tr>
                        </table>
                    </div>
                </div>
                <!--<div class="fullwidth">
                    <div class="printable-content footer-data">
                        <template>
                            <p>Merci de bien vouloir être avisé qu’en cas de constatation d’endommagement du conteneur lors de l’enlèvement du port, vous devez contacter notre agent sur place pour faire les constatations nécessaires conjointement avec l’acconier. A défaut, nous vous tiendrons responsables des montants de réparations conséquentes.</p>
                            <p>- Cet avis n ' est pas un document comptable; une facture est à exiger au moment du paiement.- Le décompte des surestaries commence à la date du débarquement et cesse le jour de la restitution de la déclaration "TD" dans le parc.NB : La caution pour le retrait des conteneurs : DC 20' =  DT, DC 40' =  4 000 DT, RF 20' = 20 000 DT, RF 40' = 40 000 DT,au delà d'un mois à partir de la date d'arrivée, la caution sera majorée.OT 20' = 3 000 OT 40' = 6 000</p>
                        </template>
                        <template>
                            <p>
                                Toute réclamation concernant la nature, la valeur ,le poids ou le nombre de colis doit être signalée par Écrit à nos services contre décharge ou par e-mail  au plus tard le lendemain de la réception du préavis avant 10h:00, passé ce délais toute modification sera à la charge des réceptionnaires
                            </p>
                            <p>
                                Franchise magasinage pour les entrepôts sous douane 7 jours à partir de la date de dépotage de la marchandise
                            </p>
                        </template>
                    </div>
                </div>-->
            </div>
        </template>
    </v-card>
</template>
<script>
    var writtenNumber = require('written-number');
    import Printd from 'printd'
    export default {
        name: 'print-magasinage-facture',
        data: () => ({
            d: null,
            docType: 'Facture',
            cssText: `
            @import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
            .uppercase{
                text-transform: capitalize;
            }
            .p-0{
                padding:0 !important;
            }
            .assiette, .assiette td {
                border-collapse: collapse;
                border-radius: 10px;
            }
            .assiette td{
                border: 1px solid gray;
            }
            .p-t-0{
                padding-top:0px !important;
            }
            .m-t-0{
                margin-top:0px !important;
            }
            .p-b-0{
                padding-bottom:0px !important;
            }
            .m-b-0{
                margin-bottom:0px !important;
            }
            .line {
                width: 95%;
                height:2px;
                border-bottom: 1px solid gray;
                margin: 0 auto;
                display: block;
            }
            .total p{
                font-size:10px;
                padding: 2px;
            }
            .total{
                padding: 10px;
                border: 1px solid gray;
                margin-left: 20px;
                margin-bottom:10px;
            }
            *{
                margin:0;
                font-family: "Montserrat",sans-serif;
                outline: none;
            }
            .right {
                text-align:right;
            }
            .no-printable {
                display:none;
            }
            .fullwidth{
                width:100%;
            }
            .width-50{
                width:50% !important;
                float:left;
            }
            .width-75{
                width:75% !important;
                float:left;
            }
            .width-33{
                width: 33% !important;
                float:left;
            }
            .width-25{
                width:25% important;
                float:left;
            }
            .printable-content{
                margin: 8px;
                padding:15px;
            }
            .logo {
                width:170px;
            }
            .info-text {
                font-size:12px !important;
                line-height:14px;
                font-weight:400 !important;
                letter-spacing:1.2px;
                color: #000;
            }
            .clearfix{
                clear:both;
            }
            .client-label{
                font-size:10px;
            }
            .coordonnee-client{
                border: 0px solid gray;
                padding:15px;
            }
            .p-t-1{
                padding-top: 15px;
            }
            .text-line{
                font-size:12px;
                font-weight:normal;
            }
            .text-line.small{
                font-size:9px !important;
                color: rgba(0,0,0,0.2)
            }
            .table-print{
                border-collapse: collapse;
            }
            .table-print td{
                padding:2px 4px;
                font-size:9px;
            }
            .table-print-reglement td{
                padding:1px 2px;
                font-size:8px;
            }
            .table-print-reglement .heading td{
                background-color: #367fc3 !important;
                color: white !important;
                padding: 5px 3px !important;
                font-weight: 700 !important;
            }
            .table-print, .table-print td{
                border: 0px solid gray;
            }
            .table-print .heading td{
                background-color: #367fc3 !important;
                color: white !important;
                padding: 7px 5px !important;
                font-weight: 700 !important;
            }
            .table-print  td{
                padding: 7px 5px;
            }
            .footer-data{
                font-size:10px;
                line-height:18px;
                letter-spacing:1.2px;
            }
            .data-dossier .single-data{
                width:33%;
                float:left;
                font-size:9px;
                margin-top:5px;
                height: 18px;
            }
            .info-bar{
                font-size: 12px;
            }
            .facture-data-row .data-value{
                text-align: left;
                font-size:9px;
                line-height:15px;
            }
            .facture-data-row .data-label{
                text-align: right;
                color: black !important;
                font-size:8px;
                padding-right:5px;
                line-height:15px;
            }
            .width-66{
                width:66% !important;
                float:left;
            }
            .border-bottom-1 td{
                border-bottom:1px solid gray;
            }
            .border-1 {
                border:1px solid gray;
                border-radius:15px;
            }
            `,
            factureToPrint: {
                client: {},
                dossier: {},
                correspondant: {},
                agent: {}
            },
            assiette: [],
            totalnt: 0,
            totalt: 0,
            totaltva: 0,
            total: 0,
            totaltext: '',
            societe: 'Prime',
            factureData: {}
            }),
        props: ['currentFacture'],
        mounted() {
            //console.log(this.currentFacture)
            if(this.currentFacture.avis_id > 0){
                if(this.currentFacture.is_magasinage === 1){
                    this.axios
                    .get('/avis/single/'+this.currentFacture.avis_id)
                    .then(response => {
                        this.axios
                            .get('/facture/single/'+this.currentFacture.id)
                            .then(result => {
                                this.factureData = {}
                                this.currentFacture.client = response.data.client
                                this.currentFacture.prestations = this.calcul(result.data.prestations)
                                this.currentFacture.marchandise = result.data.marchandise
                                this.currentFacture.dossier = response.data.dossier
                                this.currentFacture.avis = response.data
                                this.currentFacture.data = result.data.data
                                this.currentFacture.data.forEach((item, key) => {
                                    this.factureData[item.name] = item.value
                                })
                                this.factureToPrint = this.currentFacture
                                
                            })
                        
                    })
                }else{
                    this.axios
                    .get('/avis/single/'+this.currentFacture.avis_id)
                    .then(response => {
                        this.currentFacture.client = response.data.client
                        this.currentFacture.prestations = this.calcul(response.data.prestations)
                        this.currentFacture.marchandise = response.data.marchandises
                        this.currentFacture.dossier = response.data.dossier
                        this.currentFacture.avis = response.data
                        this.factureToPrint = this.currentFacture
                        
                    })
                }
                
            }else if(this.currentFacture.avis_id === 0 && this.currentFacture.dossier_id > 0){
                this.factureData = {}
                this.axios
                    .get('/dossier/single/'+this.currentFacture.dossier_id)
                    .then(response => {
                        this.currentFacture.data.forEach((item, key) => {
                            if(item.name === 'correspondant_id'){
                                this.axios
                                .get('/correspondant/listing')
                                .then(res => 
                                {
                                    this.factureToPrint.correspondant = res.data.filter(obj => {
                                        return obj.id === Number(item.value)
                                    })[0]
                                })
                                
                            }else if(item.name === 'agent_id'){
                                this.axios
                                .get('/agent/listing')
                                .then(res => 
                                {
                                    this.factureToPrint.agent = res.data.filter(obj => {
                                        return obj.id === Number(item.value)
                                    })[0]
                                })
                            }else{
                                this.factureData[item.name] = item.value
                            }
                        })
                        this.currentFacture.marchandise.forEach((item, index) => {
                            if(Number(item.cont_type_id) > 0){
                                this.axios
                                    .get('/conteneur/listing')
                                    .then(res => {
                                        item.cont_type = res.data.filter(obj => {
                                            return obj.id === item.cont_type_id
                                        })[0].titre
                                    })
                                this.factureToPrint.marchandise[index] = item
                            }
                        })
                        var self = this
                        setTimeout(function(){
                            self.factureToPrint = self.currentFacture
                            self.factureToPrint.dossier = response.data[0]
                            self.factureToPrint.factureData = self.factureData
                            self.calcul(self.factureToPrint.prestations)
                            self.factureToPrint.dossier.num_dossier = response.data[0].numdossier
                            console.log(self.factureToPrint.factureData)
                        },300)
                    })
            }else{
                
                this.currentFacture.data.forEach((item, key) => {
                    this.factureData[item.name] = item.value
                })
                if(this.currentFacture.is_da !== 0){
                    this.axios
                    .get('armateur/listing')
                    .then(response => {
                        let armateur = response.data.filter(arm => arm.id === this.currentFacture.client_id)[0]
                        var self = this
                        setTimeout(function() {
                            self.factureToPrint = self.currentFacture
                            self.calcul(self.currentFacture.prestations)
                            self.factureToPrint.armateur = armateur
                        },200)
                    })
                }else{
                    var self = this
                    setTimeout(function() {
                        self.factureToPrint = self.currentFacture
                        self.calcul(self.currentFacture.prestations)
                    },200)
                }
                
                
            }
        },
        methods: {
            print(){
                this.d = new Printd()
                this.d.print( this.$el, [this.cssText])
                this.$emit('hideDialog', true)
            },
            cancelPrint(){
                this.$emit('hideDialog', true)
            },
            calcul(prestations){
                if(this.factureToPrint.is_da == 1){
                    this.totalt = 0
                    this.total = 0
                    prestations.forEach((item , index) => {
                        item.cour = Number(item.cour)
                        item.montantDevise = Number(item.montantDevise)
                        item.montant = item.montantDevise * item.cour
                        this.totalt = item.montant + this.totalt
                        this.total = item.montantDevise + this.total
                    })
                    let tot = (this.totalt).toFixed(3)
                    var vergulepos = tot.toString().indexOf('.')
                    var bef_total = tot.toString().slice(0, vergulepos)
                    var af_total = tot.toString().slice(vergulepos+1, tot.length)
                    console.log(bef_total + ' '+ af_total)
                    this.totaltext = writtenNumber(bef_total, {lang: 'en'}) + ' dinars'
                    if(Number(af_total) > 0){
                        this.totaltext = this.totaltext + " and " + writtenNumber(af_total, {lang: 'en'}) + ' millimes'
                    }
                }else{
                    this.totalnt = 0
                    this.totalt = 0
                    this.totaltva = 0
                    this.total = 0
                    prestations.forEach((item , index) => {
                        item.cour = Number(item.cour)
                        item.montant = Number(item.montant)
                        item.montantDevise = Number(item.montantDevise)
                        item.montantTva = Number(item.montant.toFixed(3)) * item.tva / 100
                        item.tva = Number(item.tva)
                        if(item.cour > 0){
                            prestations[index].montant = item.cour * item.montantDevise
                        } 
                        if(item.tva === 0){
                            this.totalnt = item.montant + this.totalnt
                        }else{
                            this.totaltva = item.montant * item.tva / 100  + this.totaltva
                            this.totalt = item.montant + this.totalt
                        }
                        //this.assiette.push({taux: item.tva, assiette: item.montant, tva: item.montantTva})
                        let cass = this.assiette.find(o => o.taux === item.tva)
                        if(cass){
                            var index = this.assiette.indexOf(cass)
                            this.assiette[index].assiette = Number(this.assiette[index].assiette) + Number(item.montant.toFixed(3))
                            this.assiette[index].tva = Number(this.assiette[index].tva) + item.montantTva
                        }else{
                            this.assiette.push({taux: item.tva, assiette: item.montant, tva: item.montantTva})
                        }
                        
                    })
                    this.total = Number(this.total.toFixed(3)) + Number(this.totalnt.toFixed(3)) + Number(this.totalt.toFixed(3)) + Number(this.totaltva.toFixed(3)) + Number(this.currentFacture.timbre.toFixed(3))
                    let tot = (this.total).toFixed(3)
                    var vergulepos = tot.toString().indexOf('.')
                    var bef_total = tot.toString().slice(0, vergulepos)
                    var af_total = tot.toString().slice(vergulepos+1, tot.length)
                    console.log(bef_total + ' '+ af_total)
                    this.totaltext = writtenNumber(bef_total, {lang: 'fr'}) + ' dinars'
                    if(Number(af_total) > 0){
                        this.totaltext = this.totaltext + " et " + writtenNumber(af_total, {lang: 'fr'}) + ' millimes'
                    }
                }
                
                
                return prestations
            }
        }
    }
</script>
<style scoped>
.facture-data-row .data-value{
    text-align: left;
}
.facture-data-row .data-label{
    text-align: right;
    padding-right: 35px;
    color: rgba(0,0,0,0.4);
}
.width-66{
    width:66% !important;
    float:left;
}
.line {
    width: 97%;
    height:1px;
    margin: 0 auto;
    display: block;
    background: rgba(0,0,0,0.1);
}
.total p{
    padding: 2px;
}
.total{
    padding: 10px;
    border: 1px solid rgba(0,0,0,0.2);
    margin-left: 20px;
    margin-bottom:10px;
}
div {
    text-align:left;
}
.logo {
    width:170px;
}
.right {
    text-align:right;
}
.printable-content{
    margin: 8px;
    padding:15px;
}
.fullwidth{
    width:100%;
}
.width-50{
    width:50% !important;
    float:left;
}
.width-33{
    width:33% !important;
    float:left;
}
.width-75{
    width:75% !important;
    float:left;
}
.width-25{
    width:25% !important;
    float:left;
}
.info-text {
    font-size:14px !important;
    line-height:20px;
    font-weight:400 !important;
    letter-spacing:1.2px;
    color: #000;
}
.clearfix{
    clear:both;
}
.client-label{
    font-size:12px;
}
.coordonnee-client{
    border: 0px solid rgba(0,0,0,0.2);
    padding:15px;
    margin: 5px;
}
.text-line{
    font-size:12px;
    font-weight:normal;
}
.table-print{
    border-collapse: collapse;
}
.table-print td{
    padding:5px 7px;
}
.table-print, .table-print td{
    border: 0px solid rgba(0,0,0,0.2);
}
.table-print .heading td{
    background: #367fc3;
    color: white;
    padding: 15px 10px;
    font-weight: 700;
}
.footer-data{
    font-size:13px;
    line-height:20px;
    letter-spacing:1.5px;
}
.data-dossier .single-data{
    width:33%;
    height: 50px;
    float:left;
}
.border-bottom-1 td{
    border-bottom:1px solid rgba(0,0,0,0.2)
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/dossier/facture/magasinage/print.component.vue